import config from 'app/config';

import {
  SAVE_SETTINGS_REQUEST,
} from 'app/common/actions/settings/save';

import {
  SETTINGS_SUCCESS,
} from 'app/common/actions/settings/load';

const defaultState = {
  rows: config.perPageItems,
};

export default function reducer(state = defaultState, action) {
  if (action.type === SAVE_SETTINGS_REQUEST && action.payload.key && action.payload.key === 'passages') {
    const newState = { ...state, ...action.payload.obj };
    return newState;
  }
  if (action.type === SETTINGS_SUCCESS && action.payload.passages) {
    const newState = { ...action.payload.passages };
    return newState;
  }

  return state;
}
